import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class GlobalNotFoundRedirectGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    const valid = await this.authService.ensureAccessTokenValid();
    if (!valid) {
      return true;
    }

    if (this.authService.isAppAdmin) {
      return this.router.parseUrl('/admin/not-found');
    }

    if (this.authService.isOrganization) {
      return this.router.parseUrl('/organization/not-found');
    }

    return true;
  }
}
